import PickFeedbackQuestionModal from './PickFeedbackQuestionModal'

export default PickFeedbackQuestionModal
